import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import withStyles from '@material-ui/styles/withStyles';

const styles = (theme) => ({
  goWebinar: {
    width: '100%',
    height: '50%',
    borderBottom: '1px solid #eee',
    cursor: 'pointer',
  },
  closeBtn: {
    display: 'flex',
    justifyContent: 'space-between',
    '& >button': {
      backgroundColor: '#ffffff',
      border: 'none',
      color: 'black',
      fontWeight: 'bold',
      cursor: 'pointer',
    },
  },
});

class Webinar extends Component {
  // constructor(props) {
  //   super(props);
  // }

  goWebinar = () => {
    window.open('', '_self').close();
    window.open('https://prskorea2021.webconference.kr/#/', '_blank');
  };

  close = () => {
    window.open('', '_self').close();
  };

  doNotAgainOpen = () => {
    var today = new Date();
    // console.log(today.getDate());
    today.setDate(today.getDate() + 1);
    document.cookie = 'webinar_popup=' + escape('popupEnd') + '; expires=' + today.toGMTString();
    window.open('', '_self').close();
  };

  render() {
    const { classes } = this.props;

    return (
      <div style={{ height: '290px' }}>
        <div>
          <img src="/images/PRS2021/popupPage.png" alt="PRS2021" className={classes.goWebinar} onClick={this.goWebinar} />
        </div>
        <div className={classes.closeBtn}>
          <button type="button" onClick={this.doNotAgainOpen}>
            <span>Do not open again today</span>
          </button>
          <button type="button" onClick={this.close}>
            [Close]
          </button>
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(Webinar));
